// removed by extract-text-webpack-plugin
module.exports = {"app":"Zax2hA8YATuc_4EaNAJgO"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 604
// module chunks = 0